export default __webpack_public_path__ + "static/media/icone_page_500.34bd562d.svg";